import { render, staticRenderFns } from "./JobDetail.vue?vue&type=template&id=3243fd5a&scoped=true"
import script from "./JobDetail.vue?vue&type=script&lang=js"
export * from "./JobDetail.vue?vue&type=script&lang=js"
import style0 from "./JobDetail.vue?vue&type=style&index=0&id=3243fd5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3243fd5a",
  null
  
)

export default component.exports